// extracted by mini-css-extract-plugin
export default {"sentiment":"Sentiment_sentiment__Tccvo","sentimentTag":"Sentiment_sentimentTag__Sy66I"};